import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CollapsibleContainerEmptyState = () => {
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    alignItems: "center",
    marginBlockEnd: "200",
    children: [/*#__PURE__*/_jsx(Illustration, {
      width: "72px",
      marginBlock: "100",
      name: "empty-state-charts"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmCards.collapsibleContainerEmptyState"
    })]
  });
};
export default CollapsibleContainerEmptyState;